"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const PopoverBody_1 = __importDefault(require("./PopoverBody"));
const PopoverButton_1 = __importDefault(require("./PopoverButton"));
const PopoverHeader_1 = __importDefault(require("./PopoverHeader"));
require("@hotmart/cosmos/dist/popover");
const Popover = ({ children, className, position = 'top', autoShow = false }) => {
    const hotPopoverElement = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        if (autoShow && hotPopoverElement.current) {
            hotPopoverElement.current.openPopover();
        }
    }, [autoShow]);
    return ((0, jsx_runtime_1.jsx)("hot-popover", { ref: hotPopoverElement, position: position, class: className, children: children }));
};
Popover.Button = PopoverButton_1.default;
Popover.Header = PopoverHeader_1.default;
Popover.Body = PopoverBody_1.default;
exports.default = Popover;
